import { create } from "zustand";
import type {
  BindingDefaultSourceContext,
  StaticDemoDefaultSourceContext,
} from "@/services/ai/commands/utils/component-defaults";

export type RightPanelMode = "chat" | "add" | "layers";
export type AddPanelTab = "components" | "templates";
export type AddPanelSourceContext =
  | Omit<
      BindingDefaultSourceContext,
      | "projectId"
      | "pageId"
      | "selectedOrganizationId"
      | "currentOrganizationId"
    >
  | StaticDemoDefaultSourceContext;

interface RightPanelStore {
  mode: RightPanelMode;
  addTab: AddPanelTab;
  addPanelSourceContext: AddPanelSourceContext | null;
  setMode: (mode: RightPanelMode) => void;
  setAddTab: (tab: AddPanelTab) => void;
  setAddPanelSourceContext: (context: AddPanelSourceContext | null) => void;
  toggleAdd: () => void;
  toggleLayers: () => void;
}

export const useRightPanelStore = create<RightPanelStore>((set) => ({
  mode: "chat",
  addTab: "components",
  addPanelSourceContext: null,
  setMode: (mode) => set({ mode }),
  setAddTab: (addTab) => set({ addTab }),
  setAddPanelSourceContext: (addPanelSourceContext) =>
    set({ addPanelSourceContext }),
  toggleAdd: () =>
    set((state) => ({ mode: state.mode === "add" ? "chat" : "add" })),
  toggleLayers: () =>
    set((state) => ({ mode: state.mode === "layers" ? "chat" : "layers" })),
}));
